import {
  LOAD_SCCO_WEBSERVICE_LOG,
  REMOVE_LISTS,
  SEARCH_SCCO_MASTER,
  CLEAR_MASTER_SEARCH,
  LOAD_SCCO_SERVICE_NAMES,
  LOAD_RELATED_TRUCKS,
} from './actions'

export const initialState = {
  lists: [],
  total: 0,
  loading: false,
  draw: -1,
  masterLists: [],
  masterTotal: 0,
  masterLoading: false,
  relatedTrucks: [],
  relatedTrucksLoading: false,
  serviceNames: [],
  serviceNamesLoading: false,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case LOAD_SCCO_WEBSERVICE_LOG.REQUEST:
      return { ...state, loading: action.payload.loading }

    case LOAD_SCCO_WEBSERVICE_LOG.SUCCESS:
      return {
        ...state,
        lists: action.payload.lists.data,
        total: action.payload.lists.total,
        loading: false,
        draw: Math.floor(Math.random() * 999 + 1),
      }

    case LOAD_SCCO_WEBSERVICE_LOG.FAILURE:
      return { ...state, loading: false }

    case REMOVE_LISTS:
      return initialState

    case SEARCH_SCCO_MASTER.REQUEST:
      return { ...state, masterLoading: action.payload.loading }

    case SEARCH_SCCO_MASTER.SUCCESS:
      return {
        ...state,
        masterLists: action.payload.lists.data,
        masterTotal: action.payload.lists.total,
        masterLoading: false,
      }

    case SEARCH_SCCO_MASTER.FAILURE:
      return { ...state, masterLoading: false }

    case CLEAR_MASTER_SEARCH:
      return { ...state, masterLists: [], masterTotal: 0, masterLoading: false }

    case LOAD_RELATED_TRUCKS.REQUEST:
      return { ...state, relatedTrucksLoading: true, relatedTrucks: [] }

    case LOAD_RELATED_TRUCKS.SUCCESS:
      return { ...state, relatedTrucks: action.payload.list, relatedTrucksLoading: false }

    case LOAD_RELATED_TRUCKS.FAILURE:
      return { ...state, relatedTrucksLoading: false }

    case LOAD_SCCO_SERVICE_NAMES.REQUEST:
      return { ...state, serviceNamesLoading: true }

    case LOAD_SCCO_SERVICE_NAMES.SUCCESS:
      return { ...state, serviceNames: action.payload.list, serviceNamesLoading: false }

    case LOAD_SCCO_SERVICE_NAMES.FAILURE:
      return { ...state, serviceNamesLoading: false }

    default:
      return state
  }
}
